// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const createDemandMatrix = createAction('demandPlanning/createMatrix');

export const triggerSubmitDemand = createAction('demandPlanning/triggerSubmitDemand');
